"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionObserverSupported = exports.removeChatEvent = exports.createCustomEvent = exports.dispatchChatEvent = exports.OPEN_SURVEY_FIVE9_CHAT_EVENT = exports.MINIMIZE_FIVE9_CHAT_EVENT = exports.MAXIMIZE_FIVE9_CHAT_EVENT = exports.INITIALIZE_NEW_FIVE9_CHAT_EVENT = exports.INITIALIZE_CONFIGURATION_FIVE9_CHAT_EVENT = exports.SAVE_FIVE9_CHAT_EVENT = exports.FILE_ERROR_LOADED_FIVE9_CHAT_EVENT = exports.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_FIVE9_CHAT_EVENT = exports.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_EVENT = exports.SURVEY_LOADING_FIVE9_CHAT_EVENT = exports.SEND_SURVEY_ERROR_FIVE9_CHAT_EVENT = exports.SEND_SURVEY_SUCCESSFUL_FIVE9_CHAT_EVENT = exports.SEND_SURVEY_FIVE9_CHAT_EVENT = exports.FILE_LOADED_FIVE9_CHAT_EVENT = exports.CLOSE_FIVE9_CHAT_EVENT = exports.OPEN_FIVE9_CHAT_EVENT = void 0;
exports.OPEN_FIVE9_CHAT_EVENT = "OpenFive9ChatEvent";
exports.CLOSE_FIVE9_CHAT_EVENT = "CloseFive9ChatEvent";
exports.FILE_LOADED_FIVE9_CHAT_EVENT = "FileLoadedFive9ChatEvent";
exports.SEND_SURVEY_FIVE9_CHAT_EVENT = "SendSurveyFive9ChatEvent";
exports.SEND_SURVEY_SUCCESSFUL_FIVE9_CHAT_EVENT = "SendSurveySuccessfulFive9ChatEvent";
exports.SEND_SURVEY_ERROR_FIVE9_CHAT_EVENT = "SendSurveyErrorfulFive9ChatEvent";
exports.SURVEY_LOADING_FIVE9_CHAT_EVENT = "SurveyLoadingFive9ChatEvent";
exports.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_EVENT = "HiddeThanksResponsesFive9ChatEvent";
exports.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_FIVE9_CHAT_EVENT = "HideConversationHistoryFive9ChatEvent";
exports.FILE_ERROR_LOADED_FIVE9_CHAT_EVENT = "FileErrorLoadedFive9ChatEvent";
exports.SAVE_FIVE9_CHAT_EVENT = "SaveFive9ChatEvent";
exports.INITIALIZE_CONFIGURATION_FIVE9_CHAT_EVENT = "InitializeConfigurationFive9ChatEvent";
exports.INITIALIZE_NEW_FIVE9_CHAT_EVENT = "InitializeNewFive9ChatEvent";
exports.MAXIMIZE_FIVE9_CHAT_EVENT = "MaximizeFive9ChatEvent";
exports.MINIMIZE_FIVE9_CHAT_EVENT = "MinimizeFive9ChatEvent";
exports.OPEN_SURVEY_FIVE9_CHAT_EVENT = "OpenSurveyFive9ChatEvent";
var dispatchChatEvent = function (eventName, parameters) {
    return window.dispatchEvent((0, exports.createCustomEvent)(eventName, parameters));
};
exports.dispatchChatEvent = dispatchChatEvent;
var createCustomEvent = function (eventName, parameters) {
    return new CustomEvent(eventName, { detail: parameters });
};
exports.createCustomEvent = createCustomEvent;
var removeChatEvent = function (eventName, listener, options) { return window.removeEventListener(eventName, listener, options); };
exports.removeChatEvent = removeChatEvent;
var IntersectionObserverSupported = function () {
    return typeof window !== "undefined"
        ? !!window.IntersectionObserver
        : false;
};
exports.IntersectionObserverSupported = IntersectionObserverSupported;
//# sourceMappingURL=events.js.map